import React, { useEffect, useState } from 'react';
import { 
  Box, 
  Typography, 
  Paper, 
  Grid, 
  Divider, 
  CircularProgress,
  Chip,
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton
} from '@mui/material';
import { Close as CloseIcon } from '@mui/icons-material';
import CriptoWalletList from '../../wallets/CriptoWallets.list';

const IsoEnrollmentShow = ({ isoData, setIsoData }) => {
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (isoData) {
      setOpen(true);
      setLoading(true);
      console.log(isoData, 'isoData');
      setLoading(false);
    }
  }, [isoData]);

  const handleClose = () => {
    setOpen(false);
    setIsoData(null);
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      maxWidth="lg"
      fullWidth
      aria-labelledby="iso-enrollment-dialog-title"
    >
      <DialogTitle id="iso-enrollment-dialog-title" sx={{ m: 0, p: 2 }}>
        <Box display="flex" justifyContent="space-between" alignItems="center">
          <Typography variant="h6" component="div">
            ISO Enrollment Information
          </Typography>
          <IconButton
            aria-label="close"
            onClick={handleClose}
            sx={{
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon />
          </IconButton>
        </Box>
      </DialogTitle>
      
      <DialogContent dividers>
        <IsoEnrollmentShower 
          isoData={isoData} 
          loading={loading}
        />
      </DialogContent>
    </Dialog>
  );
};

// Componente separado para el contenido del modal
export const IsoEnrollmentShower = ({ isoData, loading }) => {
  const formatCurrency = (amount) => {
    if (!amount) return "0.00";
    return parseFloat(amount).toFixed(2);
  };

  const formatPercentage = (percentage) => {
    if (!percentage) return "0.0000";
    return parseFloat(percentage).toFixed(4);
  };

  const formatDate = (dateString) => {
    if (!dateString) return "N/A";
    return new Date(dateString).toLocaleDateString();
  };

  if (loading) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" minHeight="400px">
        <CircularProgress />
      </Box>
    );
  }

  if (!isoData) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" minHeight="400px">
        <Typography variant="h6" color="text.secondary">
          No ISO enrollment data found
        </Typography>
      </Box>
    );
  }

  return (
    <Box sx={{ p: 2, bgcolor: "background.default", minHeight: "60vh", maxHeight: "80vh", overflow: "auto" }}>
      {/* Header */}
      <Paper elevation={2} sx={{ p: 2, mb: 2, bgcolor: "background.paper" }}>
        <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
          <Typography variant="h5" component="h1" color="primary" fontWeight="bold">
            ISO ENROLLMENT INFORMATION
          </Typography>
          <Chip 
            label={`ID: ${isoData.isoID || 'N/A'}`} 
            color="primary" 
            variant="outlined"
          />
        </Box>
        <Typography variant="subtitle2" color="text.secondary">
          Document generated on: {new Date().toLocaleDateString()}
        </Typography>
      </Paper>

      {/* ISO Info Section */}
      <Paper elevation={2} sx={{ p: 2, mb: 2, bgcolor: "background.paper" }}>
        <Typography variant="h6" component="h2" color="primary" mb={2} fontWeight="bold">
          ISO INFORMATION
        </Typography>
        <Divider sx={{ mb: 2 }} />
        <Grid container spacing={2}>
          <Grid item xs={12} md={6}>
            <Box sx={{ mb: 2 }}>
              <Typography variant="subtitle2" color="text.secondary" fontWeight="bold">
                ISO NAME
              </Typography>
              <Typography variant="body1" sx={{ p: 1, bgcolor: "grey.50", borderRadius: 1 }}>
                {isoData.isoName || 'N/A'}
              </Typography>
            </Box>
          </Grid>
          
          <Grid item xs={12} md={6}>
            <Box sx={{ mb: 2 }}>
              <Typography variant="subtitle2" color="text.secondary" fontWeight="bold">
                CURRENCY CODE
              </Typography>
              <Typography variant="body1" sx={{ p: 1, bgcolor: "grey.50", borderRadius: 1 }}>
                {isoData.isoCurrencyCode || 'N/A'}
              </Typography>
            </Box>
          </Grid>
        </Grid>

        <Typography variant="subtitle1" component="h3" color="primary" mt={2} mb={2} fontWeight="bold">
          ADDRESS
        </Typography>
        
        <Grid container spacing={2}>
          <Grid item xs={12} md={6}>
            <Box sx={{ mb: 2 }}>
              <Typography variant="subtitle2" color="text.secondary" fontWeight="bold">
                ADDRESS
              </Typography>
              <Typography variant="body1" sx={{ p: 1, bgcolor: "grey.50", borderRadius: 1 }}>
                {isoData?.iso?.address || 'N/A'}
              </Typography>
            </Box>
          </Grid>
          
          <Grid item xs={12} md={6}>
            <Box sx={{ mb: 2 }}>
              <Typography variant="subtitle2" color="text.secondary" fontWeight="bold">
                CITY
              </Typography>
              <Typography variant="body1" sx={{ p: 1, bgcolor: "grey.50", borderRadius: 1 }}>
                {isoData?.iso?.city || 'N/A'}
              </Typography>
            </Box>
          </Grid>
          
          <Grid item xs={12} md={4}>
            <Box sx={{ mb: 2 }}>
              <Typography variant="subtitle2" color="text.secondary" fontWeight="bold">
                STATE/PROVINCE
              </Typography>
              <Typography variant="body1" sx={{ p: 1, bgcolor: "grey.50", borderRadius: 1 }}>
                {isoData?.iso?.state || 'N/A'}
              </Typography>
            </Box>
          </Grid>
          
          <Grid item xs={12} md={4}>
            <Box sx={{ mb: 2 }}>
              <Typography variant="subtitle2" color="text.secondary" fontWeight="bold">
                POSTAL CODE
              </Typography>
              <Typography variant="body1" sx={{ p: 1, bgcolor: "grey.50", borderRadius: 1 }}>
                {isoData?.iso?.postalCode || 'N/A'}
              </Typography>
            </Box>
          </Grid>
          
          <Grid item xs={12} md={4}>
            <Box sx={{ mb: 2 }}>
              <Typography variant="subtitle2" color="text.secondary" fontWeight="bold">
                COUNTRY CODE
              </Typography>
              <Typography variant="body1" sx={{ p: 1, bgcolor: "grey.50", borderRadius: 1 }}>
                {isoData?.iso?.countryCode || 'N/A'}
              </Typography>
            </Box>
          </Grid>
        </Grid>
      </Paper>

      {/* Commissions Section */}
      <Paper elevation={2} sx={{ p: 2, mb: 2, bgcolor: "background.paper" }}>
        <Typography variant="h6" component="h2" color="primary" mb={2} fontWeight="bold">
          COMMISSIONS AND FEES
        </Typography>
        <Divider sx={{ mb: 2 }} />
        
        <Grid container spacing={2}>
          <Grid item xs={12} md={6}>
            <Box sx={{ mb: 2 }}>
              <Typography variant="subtitle2" color="text.secondary" fontWeight="bold">
                PROCESSING TRANSACTION FEE
              </Typography>
              <Typography variant="body1" sx={{ p: 1, bgcolor: "grey.50", borderRadius: 1 }}>
                ${formatCurrency(isoData?.iso?.amountTxProcessing)}
              </Typography>
            </Box>
          </Grid>
          
          <Grid item xs={12} md={6}>
            <Box sx={{ mb: 2 }}>
              <Typography variant="subtitle2" color="text.secondary" fontWeight="bold">
                MDR PERCENTAGE FEE
              </Typography>
              <Typography variant="body1" sx={{ p: 1, bgcolor: "grey.50", borderRadius: 1 }}>
                {formatPercentage(isoData?.iso?.percentTxProcessing)}%
              </Typography>
            </Box>
          </Grid>
        </Grid>
      </Paper>

      {/* Bank Information Section */}
      <Paper elevation={2} sx={{ p: 2, mb: 2, bgcolor: "background.paper" }}>
        <Typography variant="h6" component="h2" color="primary" mb={2} fontWeight="bold">
          BANKING INFORMATION
        </Typography>
        <Divider sx={{ mb: 2 }} />
        
        <Grid container spacing={2}>
          <Grid item xs={12} md={6}>
            <Box sx={{ mb: 2 }}>
              <Typography variant="subtitle2" color="text.secondary" fontWeight="bold">
                BANK NAME
              </Typography>
              <Typography variant="body1" sx={{ p: 1, bgcolor: "grey.50", borderRadius: 1 }}>
                {isoData?.bank?.Iban || 'N/A'}
              </Typography>
            </Box>
          </Grid>
          
          <Grid item xs={12} md={6}>
            <Box sx={{ mb: 2 }}>
              <Typography variant="subtitle2" color="text.secondary" fontWeight="bold">
                BANK ADDRESS
              </Typography>
              <Typography variant="body1" sx={{ p: 1, bgcolor: "grey.50", borderRadius: 1 }}>
                {isoData?.bank?.address || 'N/A'}
              </Typography>
            </Box>
          </Grid>
          
          <Grid item xs={12} md={6}>
            <Box sx={{ mb: 2 }}>
              <Typography variant="subtitle2" color="text.secondary" fontWeight="bold">
                ROUTING NUMBER
              </Typography>
              <Typography variant="body1" sx={{ p: 1, bgcolor: "grey.50", borderRadius: 1 }}>
                {isoData?.bank?.routingNumber || 'N/A'}
              </Typography>
            </Box>
          </Grid>
          
          <Grid item xs={12} md={6}>
            <Box sx={{ mb: 2 }}>
              <Typography variant="subtitle2" color="text.secondary" fontWeight="bold">
                ACCOUNT NUMBER
              </Typography>
              <Typography variant="body1" sx={{ p: 1, bgcolor: "grey.50", borderRadius: 1 }}>
                {isoData?.bank?.accountNumber || 'N/A'}
              </Typography>
            </Box>
          </Grid>
        </Grid>
      </Paper>
      <Paper elevation={2} sx={{ p: 2, mb: 2, bgcolor: "background.paper" }}>
        <Typography variant="h6" component="h2" color="primary" mb={2} fontWeight="bold">
          WALLET ADDRESS
        </Typography>
        <Divider sx={{ mb: 2 }} />
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Box sx={{ mb: 2 }}>
              <CriptoWalletList wallets={isoData.crypto_wallets} />
            </Box>
          </Grid>
        </Grid>
      </Paper>
    </Box>
  );
};

export default IsoEnrollmentShow;
